import React, { Component } from 'react';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';

interface IProps{
    cardJSON
}

interface IState{
    slideIndex
}

function handleCardClick(handleSubmit , cardJSON){
    if(cardJSON.extraInfo.actionText){
        handleSubmit(cardJSON.extraInfo.actionText);
    }else{
        window.open(cardJSON.e.footer.action.url,"_blank")
    }
}

export let SFCard = (props) => {
    return(
        <div className="sf-card" onClick={handleCardClick.bind(null,props.handleSubmit,props.e)}>
            <div className='sf-card-header'>
                <b>{props.e.header.mainText}</b>
                <div>{props.e.header.subText}</div>
            </div>
            {(props.e.body && props.e.body.url.length > 0) ? 
                <div className='sf-card-body'>
                    {getImgOrVideo(props.e)}
                </div>
                : 
                null
             }
            {(props.e.footer && props.e.footer.mainText.length > 0) ? 
             <div className='sf-card-footer'>
                <p>{props.e.footer.mainText}</p>
                <div>{props.e.footer.subText}</div>
                { 
                    props.e.footer.action.text.length > 0 ?
                        <button>
                            <a target="_blank" href={props.e.footer.action.url} >{props.e.footer.action.text}</a>
                        </button> 
                    : null
                }
            </div>
                :
                null
            }
        </div>
    )
}

function sanitizeYTIframe(ytIframeUrl){
    let src = ytIframeUrl;
    if(ytIframeUrl.includes("src=")){
        src = /src=".*?"/.exec(ytIframeUrl)[0]
        src = src.replace("src=","").replace(/\"/g,"");
    }

    return src
}

function getImgOrVideo(e){
    if(e.body.type == "image"){
        return <img src={e.body.url} />
    }
    else 
    return <iframe width="100%" src={sanitizeYTIframe(e.body.url)}
             frameBorder="0" allow="autoplay; encrypted-media" allowFullScreen>
           </iframe>
    
}

class CardComponent extends Component<IProps,IState> {
    constructor(props){
        super(props);

        this.state = {
            slideIndex : 0
        }
    }

    render() {
        var mockCardJSON = this.props.cardJSON ? this.props.cardJSON : [];
        return (
            <div className='sf-carousel'>
            <Carousel
                showThumbs={false}
                emulateTouch={true}
            >
              {
                  mockCardJSON.map((e,i) => {
                    return(
                        <SFCard e={e} key={i} />
                    )
                })
            }
            </Carousel>
            <br />
            </div>
        );
    }
}

export default CardComponent;